/**
 * Photo types for the admin photo manager
 */

export interface Photo {
  photoId: string;
  s3Key: string;
  filename: string;
  caption: string;
  order: number;
  uploadedAt: string;
  uploadedBy?: string;
  contentType: string;
  fileSize: number;
  thumbnailGenerated: boolean;
  visible: boolean;
  metadata?: PhotoMetadata;
}

export interface PhotoMetadata {
  width?: number;
  height?: number;
  exif?: Record<string, unknown>;
}

export interface CreatePhotoInput {
  s3Key: string;
  filename: string;
  caption?: string;
  contentType: string;
  fileSize: number;
}

export interface UploadResult {
  success: boolean;
  s3Key?: string;
  photoId?: string;
  error?: string;
}

export interface PhotoOrderUpdate {
  photoId: string;
  order: number;
}

// Upload constraints
export const UPLOAD_CONSTRAINTS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.webp'],
} as const;

// Helper function to validate file type
export const isValidImageType = (file: File): boolean => {
  console.log('[DEBUG isValidImageType] Validating file:', file.name, 'type:', file.type);
  return UPLOAD_CONSTRAINTS.ALLOWED_TYPES.includes(file.type as typeof UPLOAD_CONSTRAINTS.ALLOWED_TYPES[number]);
};

// Helper function to validate file size
export const isValidFileSize = (file: File): boolean => {
  console.log('[DEBUG isValidFileSize] File size:', file.size, 'max:', UPLOAD_CONSTRAINTS.MAX_FILE_SIZE);
  return file.size <= UPLOAD_CONSTRAINTS.MAX_FILE_SIZE;
};

// Helper function to format file size for display
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
